import SentimentAnalysis from '@/domains/shared/components/demos/SentimentAnalysis';

export default function Demo({
	                             src,
	                             demo,
                             }) {
	if (demo === null) {
		return (<div className="">
			<iframe className="w-full aspect-square shadow-2xl rounded-xl"
			        src={src}
			/>
		</div>);
	} else {
		switch (demo) {
			case 'sentiment-analysis':
				return <SentimentAnalysis />;
		}
	}

	return null;
}